class GmwCurrencyPrecision {
    static factory() {
        const factoryFunction = (HoldingCurrencies) => {
            return (input) => {
                if (!input) {
                    return undefined;
                }
                const currency = HoldingCurrencies.getCurrencyByCode(input.currency || input);
                return currency.decimals;
            };
        };
        factoryFunction.$inject = ['HoldingCurrencies'];
        return factoryFunction;
    }
}
export default angular
    .module('app.currencies')
    .filter('holdingCurrencyPrecision', GmwCurrencyPrecision.factory())
    .name;



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/currencies/filters/currency-precision.ts